import React from 'react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { SlotsPlaceholder } from '@wix/widget-plugins-ooi';
import { SlotContextProvider } from '@wix/widget-plugins-ooi-context';
import { Subscription } from '@wix/ambassador-billing-v1-subscription/types';
import { Subscription as StoresSubscription } from '@wix/ambassador-wix-ecommerce-subscriptions/types';
import { SUBSCRIPTION_DETAILS_SLOT_ID } from '../../constants';
import { buildLineItemResources } from '../../lineItemResources';
import { Experiments } from '../../../../Experiments';

interface Props {
  subscription: Subscription;
  storesSubscription: StoresSubscription | undefined;
}

const SubscriptionLineItemsBass = ({ subscription, storesSubscription }: Props) => {
  const { experiments } = useExperiments();

  const [firstResource] = experiments.enabled(Experiments.EDIT_LINE_ITEMS)
    ? buildLineItemResources(subscription, storesSubscription)
    : [];

  if (!firstResource) {
    return null;
  }

  return (
    <div data-hook="subscription-line-items-slot">
      <SlotContextProvider resourceId={firstResource.subscriptionId}>
        <SlotsPlaceholder slotId={SUBSCRIPTION_DETAILS_SLOT_ID} />
      </SlotContextProvider>
    </div>
  );
};

export default SubscriptionLineItemsBass;
